<template>
    <div class="page-container">
        <div class="area-container">
            <div class="area-tools">
                <el-tooltip class="box-item" effect="light" content="添加" placement="bottom">
                    <el-button
                        type="primary"
                        plain
                        size="small"
                        :icon="Plus"
                        v-permission="['building:add']"
                        @click="handleAddNode"
                    ></el-button>
                </el-tooltip>
                <el-tooltip class="box-item" effect="light" content="编辑" placement="bottom">
                    <el-button
                        type="primary"
                        plain
                        size="small"
                        :icon="Edit"
                        v-permission="['building:edit']"
                        @click="handleEditNode"
                    ></el-button>
                </el-tooltip>
                <el-tooltip class="box-item" effect="light" content="导入" placement="bottom">
                    <el-button
                        type="info"
                        plain
                        size="small"
                        :icon="Download"
                        @click="handleImports('building')"
                        v-permission="['building:import']"
                    ></el-button>
                </el-tooltip>
                <el-tooltip class="box-item" effect="light" content="导出" placement="bottom">
                    <el-button
                        type="info"
                        plain
                        size="small"
                        :icon="Upload"
                        @click="handleExport('building')"
                        v-permission="['building:export']"
                    ></el-button>
                </el-tooltip>
                <el-tooltip class="box-item" effect="light" content="删除" placement="bottom">
                    <el-button
                        type="danger"
                        plain
                        size="small"
                        :icon="Delete"
                        v-permission="['building:remove']"
                        @click="handleRemoveNode"
                    ></el-button>
                </el-tooltip>
                <el-tooltip class="box-item" effect="light" content="设置风机盘管运行功率" placement="bottom">
                    <el-button type="primary" plain size="small" :icon="Setting" @click="openFanPower(current_node)"></el-button>
                </el-tooltip>
            </div>
            <el-scrollbar>
                <el-tree
                    ref="area_tree"
                    node-key="id"
                    :props="{
                        children: 'children',
                        label: 'name'
                    }"
                    :data="treeData"
                    :expand-on-click-node="false"
                    :default-expanded-keys="default_expanded_keys"
                    highlight-current
                    show-checkbox
                    :check-on-click-leaf="false"
                    @node-click="handleNodeClick"
                />
                <AddUnitOrArea
                    v-model="formDialogVisible"
                    :nodeOptionLists="treeData"
                    :parentId="parentId"
                    :parentNodeType="parentNodeType"
                    :formId="node_id"
                    @updateForm="getTreeData"
                />
            </el-scrollbar>
        </div>
        <div class="data-container">
            <div class="tool-box">
                <el-button type="primary" :icon="Refresh" @click="getTableData">刷新</el-button>
                <el-button type="primary" plain :icon="Plus" @click="handleAddRoom" v-permission="['room:add']">添加</el-button>
                <el-button type="primary" plain :icon="Download" @click="handleImports('room')" v-permission="['room:import']">
                    导入
                </el-button>
                <el-button type="primary" plain :icon="Upload" @click="handleExport('room')" v-permission="['room:export']">
                    导出
                </el-button>
                <el-button type="primary" plain :icon="Delete" @click="onRemoveClick(selected_ids)">批量删除</el-button>
            </div>
            <el-form class="search-form" :inline="true" :model="search_data" label-position="top">
                <el-form-item label="房间名">
                    <el-input v-model="search_data.name" clearable placeholder="请输入" style="width: 200px" />
                </el-form-item>
                <el-form-item label="房间类型">
                    <el-select v-model="search_data.room_type" clearable placeholder="请选择" style="width: 200px">
                        <el-option v-for="item in roomType" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :icon="Search" plain @click="getTableData">搜索</el-button>
                    <el-button :icon="Refresh" @click="resetQueryForm">重置</el-button>
                </el-form-item>
            </el-form>
            <el-table
                class="data-table"
                :data="table_data"
                table-layout="auto"
                v-loading="tableLoading"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column label="序号" type="index" width="60" />
                <el-table-column prop="name" label="房间名称" />
                <el-table-column prop="room_type" label="房间类型">
                    <template #default="scope">
                        {{ roomObj[scope.row.room_type] ? roomObj[scope.row.room_type].label : '-' }}
                    </template>
                </el-table-column>
                <el-table-column prop="location" label="区域" />
                <el-table-column prop="area_size" label="房间面积">
                    <template #default="scope">
                        {{ scope.row.area_size ? scope.row.area_size + '㎡' : '--' }}
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template #default="{ row }">
                        <el-button type="primary" link @click="onEditRoom(row)" v-permission="['room:edit']">修改</el-button>
                        <el-button type="primary" link @click="onRemoveClick([row.id])" v-permission="['room:remove']">
                            删除
                        </el-button>
                        <el-button type="primary" link @click="handleMeter(row)">抄表收费</el-button>
                        <el-button type="primary" link @click="openSetHouse(row)">设置户主</el-button>
                        <!-- <el-button type="primary" link @click="openReset(row)">充值</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                v-if="table_data.length > 0"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page_params.page"
                :page-sizes="[10, 20, 50]"
                :page-size="page_params.page_size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            ></el-pagination>
            <AddRoom
                v-model="roomVisible"
                :sourceData="treeData"
                :cascaderData="node_path"
                v-model:roomId="roomId"
                :statusOptions="statusOptions"
                :roomType="roomType"
                @updateTable="getTableData"
            />
            <ImportsForm v-model="importsVisible" @updateForm="getTableData" :menuCode="exportType" />
            <el-dialog v-model="meterVisible" title="抄表收费" width="80%" @before-close="meterVisible = false" top="2vh">
                <MeterReading />
            </el-dialog>
        </div>
        <SetHouseholderDialog ref="houseDialogRef" @success="getTableData" />
        <ResetAmountDialog ref="resetRef" @success="getTableData" />
        <FanPowerDialog ref="fanPowerRef" @success="getTreeData" />
    </div>
</template>

<script setup>
import { nextTick, onMounted, reactive, ref } from 'vue'
import { Delete, Download, Edit, Plus, Refresh, Search, Setting, Upload } from '@element-plus/icons'
import {
    areaBatchDelete,
    getBuildingLists,
    getBuildingTree,
    getRoomLists,
    getRoomTypeOptionLists,
    roomBatchDelete
} from '@/api/building.js'
import AddUnitOrArea from './components/AddUnitOrArea'
import AddRoom from './components/AddRoom.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import ImportsForm from '@/components/ImportsForm.vue'
import MeterReading from './components/MeterReading.vue'
import SetHouseholderDialog from './components/SetHouseholderDialog.vue'
import ResetAmountDialog from './components/ResetAmountDialog.vue'
import FanPowerDialog from './components/FanPowerDialog.vue'
import { getDataCodeOptions } from '@/utils/common'

// 区域树形数据
const area_tree = ref(null)
const treeData = ref([])
const default_expanded_keys = ref([])
function getTreeData() {
    getBuildingTree().then((data) => {
        treeData.value = data
        nextTick(() => {
            default_expanded_keys.value = [treeData.value[0].id]
            area_tree.value.setCurrentKey(treeData.value[0].id)
            current_node.value = treeData.value[0]
        })
        getTableData()
    })
}

//点击树形节点
const current_node = ref(null)
const node_path = ref([])
const handleNodeClick = (node) => {
    current_node.value = node
    search_data.building = node.id
    node_path.value = node.parent_lists
    page_params.page = 1
    total.value = 0
    getTableData()
}

// 添加区域
const formDialogVisible = ref(false)
const parentId = ref('')
const parentNodeType = ref('')
const handleAddNode = () => {
    if (current_node.value && current_node.value.node_type === 4) {
        ElMessage({ message: '该节点下不能添加楼层区域！', type: 'warning' })
        return
    }
    node_id.value = ''
    parentId.value = current_node.value?.id || ''
    parentNodeType.value = current_node.value?.node_type || null
    if (parentId.value === '' && treeData.value.length > 0) {
        ElMessage({
            type: 'warning',
            message: '请选择一个上级节点!'
        })
        return
    }
    formDialogVisible.value = true
}

// 编辑
const node_id = ref('')
const handleEditNode = () => {
    if (!current_node.value) {
        ElMessage({ message: '请选择一条数据！', type: 'warning' })
        return
    }
    if (current_node.value) {
        node_id.value = current_node.value.id
        formDialogVisible.value = true
    } else {
        ElMessage({
            type: 'warning',
            message: '该节点不可修改！'
        })
    }
}

// 删除区域
function handleRemoveNode() {
    const checked_keys = area_tree.value.getCheckedKeys()
    if (checked_keys.length === 0) {
        ElMessage({
            type: 'warning',
            message: '请勾选要删除的区域!'
        })
        return
    }
    ElMessageBox.confirm('确定要删除勾选的区域吗？', '提示', {
        type: 'warning'
    }).then(() => {
        areaBatchDelete({
            id_list: checked_keys
        }).then(() => {
            getTreeData()
        })
    })
}

// 表格搜索
const search_data = reactive({
    status: '',
    name: '',
    room_type: '',
    building: ''
})

// 表格所需字典
const statusOptions = ref([])
function getStatusOptions() {
    getDataCodeOptions('common_status').then(({ list }) => {
        statusOptions.value = list.map((ele) => {
            return {
                ...ele,
                value: Number(ele.value)
            }
        })
    })
}
const roomType = ref([])
const roomObj = ref({})
function getRoomType() {
    getRoomTypeOptionLists().then((res) => {
        roomType.value = res
        res.forEach((item) => {
            roomObj.value[item.id] = {
                label: item.name,
                ...item
            }
        })
    })
}

// 表格数据
const table_data = ref([])
const tableLoading = ref(true)
const total = ref(0)

// 获取列表数据
async function getTableData() {
    tableLoading.value = true
    const params = { ...search_data, ...page_params }
    getRoomLists(params).then((data) => {
        table_data.value = data.lists
        total.value = data.total
        tableLoading.value = false
    })
}

// 重置
const resetQueryForm = () => {
    Object.keys(search_data).forEach((key) => {
        if (key !== 'building') search_data[key] = ''
    })
    getTableData()
}

// 分页相关
const page_params = reactive({
    page: 1,
    page_size: 10
})
const handleSizeChange = (currentSize) => {
    page_params.page_size = currentSize
    getTableData()
}
const handleCurrentChange = (currentPage) => {
    page_params.page = currentPage
    getTableData()
}

// 添加房间
const roomVisible = ref(false)
const roomId = ref('')
const handleAddRoom = () => {
    if (current_node.value && current_node.value.node_type !== 4) {
        ElMessage({ message: '该节点下不能添加房间！', type: 'warning' })
        return
    }
    roomId.value = ''
    roomVisible.value = true
}

// 导入
const exportType = ref('')
const importsVisible = ref(false)
const handleImports = (type) => {
    exportType.value = type
    importsVisible.value = true
}
// 导出
const handleExport = (type) => {
    const msg = type === 'room' ? '房间' : '区域节点'
    ElMessageBox.confirm(`是否确认导出${msg}列表`, '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
    })
        .then(async () => {
            let data
            if (type === 'room') {
                data = await getRoomLists({
                    export: 1,
                    building: current_node.value.id,
                    ...search_data
                })
            } else if (type === 'building') {
                data = await getBuildingLists({ export: 1 })
            }
            window.open(data.data)
            ElMessage({
                type: 'success',
                message: '导出成功'
            })
        })
        .catch(() => {})
}

// 表格多选
const selected_ids = ref([])
function handleSelectionChange(list) {
    selected_ids.value = list.map((item) => {
        return item.id
    })
}

// 编辑房间
const onEditRoom = (row) => {
    roomId.value = row.id
    roomVisible.value = true
}

// 删除房间
function onRemoveClick(ids) {
    ElMessageBox.confirm('确定要删除选中的房间？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
    }).then(() => {
        roomBatchDelete({ id_list: ids }).then(() => {
            ElMessage.success('删除成功')
            getTableData()
        })
    })
}

const meterVisible = ref(false)
// 抄表收费
const handleMeter = (row) => {
    roomId.value = row.id
    meterVisible.value = true
}
const houseDialogRef = ref(null)

// 打开设置户主
function openSetHouse(row) {
    houseDialogRef.value.open(row)
}
const resetRef = ref(null)

// 打开重置弹窗
function openReset(row) {
    resetRef.value.open(row)
}
const fanPowerRef = ref(null)

function openFanPower(row) {
    fanPowerRef.value.open(row)
}

onMounted(async () => {
    getStatusOptions()
    getRoomType()

    getTreeData()
})
</script>

<style lang="scss" scoped>
.area-container {
    width: 300px;
}
</style>
